module.exports = __webpack_public_path__ + "img/index-2025-logo.ddd7a320.png";